// Contact Form component
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../../styles/contact/CTAForm.css';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPaperPlane, faMessage } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';


const CustomAlert = ({ show, onClose, message }) => {
    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton style={{ borderBottom: '2px solid #166534' }}>
          <Modal.Title style={{ color: '#166534', fontWeight: '600' }}>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '16px', color: '#374151' }}>{message}</Modal.Body>
        <Modal.Footer style={{ borderTop: '2px solid #166534' }}>
          <Button
            style={{
              backgroundColor: '#166534',
              color: 'white',
              border: 'none',
              padding: '10px 30px',
              borderRadius: '25px',
              fontWeight: '600'
            }}
            onClick={onClose}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

export const ContactForm = () => {
  // Contact form structure and logic
  const form = useRef();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const MAILING_PUBLIC_KEY = process.env.REACT_APP_MAILING_PUBLIC_KEY;



  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_mmsxiya', 'template_crkv29a', form.current, {
        publicKey: MAILING_PUBLIC_KEY
        
      })
      .then(
        () => {
            setAlertMessage('Message sent successfully!');
            setShowAlert(true);
          e.target.reset();
        },
        (error) => {
            setAlertMessage('Error: Message not sent!', error.text);
            setShowAlert(true);
        },
      );
  };

  return (
    <div className='contact-form'>
        <form ref={form} onSubmit={sendEmail} className="cta-form">
            <div className="form-group">
                <div className="input-wrapper">
                    <FontAwesomeIcon icon={faUser} className="input-icon" />
                    <input type="text" name="from_name" placeholder="Your Name" className="cta-name" required/>
                </div>
            </div>
            <div className="form-group">
                <div className="input-wrapper">
                    <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                    <input type="email" name="from_email" placeholder="Your Email" className="cta-email" required/>
                </div>
            </div>
            <div className="form-group">
                <div className="input-wrapper">
                    <FontAwesomeIcon icon={faPaperPlane} className="input-icon" />
                    <input type="text" name="message_subject" placeholder="Subject" className="cta-subject" required/>
                </div>
            </div>
            <div className="form-group">
                <div className="input-wrapper textarea-wrapper">
                    <FontAwesomeIcon icon={faMessage} className="input-icon textarea-icon" />
                    <textarea name="message" placeholder="Your Message" className="cta-message" required></textarea>
                </div>
            </div>
            <button type="submit" className="cta-submit-btn">
                Send Message
                <FontAwesomeIcon icon={faPaperPlane} className="btn-icon" />
            </button>
        </form>
        <CustomAlert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
        />
    </div>
  );
};